import React from "react";
import moment from "moment";
import { TrackingTimeFormat, TrackingTimeFormatVisual } from "./TrackingUtils";

const InlineTimelineVisualization = ({
  shifts = [],
  breaks = [],
  summary = {},
  className = "",
}) => {
  // Helper functions
  const formatDuration = (duration) => {
    if (!duration) return "0m";
    const [hours, minutes] = duration.split(":");
    const h = parseInt(hours);
    const m = parseInt(minutes);

    if (h === 0) return `${m}m`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}m`;
  };

  const calculateTimelinePosition = (time) => {
    // Fixed 24-hour timeline: 00:00 to 23:59
    if (!time) return 0;

    const timeMoment = moment(time, [
      "HH:mm",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ]);
    if (!timeMoment.isValid()) {
      console.warn("Invalid time format:", time);
      return 0;
    }

    const timeMinutes = timeMoment.hour() * 60 + timeMoment.minute();
    const totalDayMinutes = 24 * 60; // 1440 minutes in a day

    const position = Math.max(
      0,
      Math.min(100, (timeMinutes / totalDayMinutes) * 100)
    );
    return position;
  };

  return (
    <div className={`keka-timeline-wrapper ${className}`}>
      {/* 24-hour Timeline Visualization */}
      <div className="keka-timeline-container">
        {/* Time markers */}
        <div className="keka-timeline-markers">
          <span className="time-marker">12 AM</span>
          <span className="time-marker">6 AM</span>
          <span className="time-marker">12 PM</span>
          <span className="time-marker">6 PM</span>
          <span className="time-marker">12 AM</span>
        </div>

        <div className="keka-timeline-track">
          {/* Base timeline bar */}
          <div className="keka-timeline-base"></div>

          {/* Render shift blocks */}
          {shifts &&
            shifts.map((shift, index) => {
              const startPos = calculateTimelinePosition(
                shift.shift_start_time
              );
              const endPos = calculateTimelinePosition(shift.shift_end_time);
              const width = Math.max(1, endPos - startPos);

              return (
                <div
                  key={`shift-${index}`}
                  className="keka-shift-block"
                  style={{
                    left: `${startPos}%`,
                    width: `${width}%`,
                  }}
                  title={`Shift ${index + 1}: ${TrackingTimeFormatVisual(
                    shift.shift_start_time
                  )} - ${TrackingTimeFormatVisual(shift.shift_end_time)}`}
                />
              );
            })}

          {/* Render break blocks */}
          {breaks &&
            breaks.map((breakItem, index) => {
              const startPos = calculateTimelinePosition(
                breakItem.break_start_time
              );

              const endTime =
                breakItem.break_end_time &&
                breakItem.break_end_time !== "00:00:00"
                  ? breakItem.break_end_time
                  : moment(breakItem.break_start_time)
                      .add(10, "minutes")
                      .format("YYYY-MM-DD HH:mm:ss");

              const endPos = calculateTimelinePosition(endTime);
              const width = Math.max(0.5, endPos - startPos);
              const isOutOfRange = breakItem.break_name === "out_of_range";

              return (
                <div
                  key={`break-${index}`}
                  className={`keka-break-block ${
                    isOutOfRange ? "out-of-range" : "regular-break"
                  }`}
                  style={{
                    left: `${startPos}%`,
                    width: `${width}%`,
                  }}
                  title={`${
                    isOutOfRange
                      ? "⚠️ Out of Range"
                      : `☕ ${breakItem.break_name}`
                  } - Duration: ${formatDuration(
                    breakItem.break_duration_hms
                  )} | Time: ${TrackingTimeFormat(breakItem.break_start_time)}`}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default InlineTimelineVisualization;
